var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOshKosh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 97,
    viewBox: "0 0 187 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_211_78)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.5886 81.5591L73.2858 82.4603C73.2858 82.4603 64.3522 85.7647 64.5036 93.7254C64.5036 93.7254 64.8064 97.7808 71.6202 95.9784C71.6202 95.9784 77.9797 94.6266 80.251 79.3061C80.251 79.3061 83.5822 78.4049 85.3992 75.7013C85.3992 75.7013 87.6704 80.3575 93.5757 79.3061C93.5757 79.3061 99.6324 78.5551 100.844 69.3928C100.844 69.3928 107.506 68.4916 109.626 64.1358C109.626 64.1358 111.746 65.4876 111.291 69.6933C111.291 69.6933 111.291 73.7487 105.689 72.5471C105.689 72.5471 104.629 71.6459 103.721 72.3969C103.721 72.3969 103.115 74.3495 105.992 75.4009C105.992 75.4009 115.683 77.3535 115.985 70.2941C115.985 70.2941 116.137 67.8908 114.017 65.6378C114.017 65.6378 113.26 59.4796 110.686 57.6772C110.686 57.6772 109.474 57.3768 108.566 59.4796C108.566 59.4796 106.9 67.5904 98.421 67.5904C98.421 67.5904 98.1182 75.7013 93.5757 75.2507C93.5757 75.2507 90.3959 74.9503 91.153 68.4916C91.153 68.4916 92.0615 62.9342 95.9984 64.1358C95.9984 64.1358 97.3611 64.4362 97.6639 65.4876H99.7838C99.7838 65.4876 100.692 61.282 93.4243 61.4322C93.4243 61.4322 86.4591 60.8314 86.0048 71.6459C86.0048 71.6459 84.7935 75.5511 81.7652 75.8515L82.8251 65.788C82.8251 65.788 82.6737 63.6852 80.5538 63.535C80.5538 63.535 78.5854 63.535 77.6769 65.3374C77.6769 65.3374 72.6801 61.1318 67.8348 69.543C67.8348 69.543 63.1409 80.6579 68.4405 81.2587C68.1376 81.2587 71.6202 81.7093 73.5886 81.5591Z",
    fill: "#21275B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.411 18.7752L128.402 42.5069H113.411L104.781 28.2378L100.995 32.4434V42.5069H88.7305V2.55347H100.995V16.6723L112.806 2.55347H128.099L113.411 18.7752Z",
    fill: "#21275B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187 42.5069H132.036V37.7004H187V42.5069Z",
    fill: "#21275B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.0963 42.5069H39.3684V37.7004H85.0963V42.5069Z",
    fill: "#21275B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.129 17.8739H179.278V10.2136H187V33.6449H179.278V24.7831H174.129V33.6449H166.407V10.2136H174.129V17.8739Z",
    fill: "#21275B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.2259 17.8739H77.3741V10.2136H85.0964V33.6449H77.3741V24.7831H72.2259V33.6449H64.5037V10.2136H72.2259V17.8739Z",
    fill: "#21275B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.755 26.7356H152.174C152.174 26.7356 152.477 29.5894 154.9 29.5894C157.322 29.5894 157.928 26.4352 155.202 25.534C152.477 24.6328 145.36 23.7316 145.36 17.273C145.36 10.8143 152.477 9.76294 154.445 9.76294C156.565 9.76294 163.833 10.8143 163.833 17.1228H156.868C156.868 17.1228 156.717 14.7196 154.597 14.7196C152.477 14.7196 150.963 17.8738 155.202 18.9252C159.442 19.9766 164.59 21.9292 164.59 27.1862C164.59 32.4433 160.048 34.9967 154.748 34.9967C150.66 34.9967 144.755 32.7437 144.755 26.7356Z",
    fill: "#21275B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.8511 26.7356H50.2705C50.2705 26.7356 50.5733 29.5894 52.996 29.5894C55.4187 29.5894 56.0244 26.4352 53.2988 25.534C50.5733 24.6328 43.4567 23.7316 43.4567 17.273C43.4567 10.8143 50.4219 9.76294 52.5418 9.76294C54.6616 9.76294 61.9296 10.8143 61.9296 17.1228H54.9644C54.9644 17.1228 54.813 14.7196 52.6932 14.7196C50.5733 14.7196 49.0592 17.8738 53.2988 18.9252C57.5385 19.9766 62.6867 21.9292 62.6867 27.1862C62.6867 32.4433 58.1442 34.9967 52.8446 34.9967C48.7563 34.9967 42.8511 32.7437 42.8511 26.7356Z",
    fill: "#21275B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.43 9.61279C137.789 9.61279 143.089 15.3204 143.089 22.2297C143.089 29.2891 137.941 34.8465 131.43 34.8465C125.07 34.8465 119.771 29.1389 119.771 22.2297C119.922 15.3204 125.07 9.61279 131.43 9.61279Z",
    fill: "#21275B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.493 22.2296C127.493 25.8345 129.31 28.6883 131.581 28.6883C133.853 28.6883 135.67 25.8345 135.67 22.2296C135.67 18.6248 133.853 15.771 131.581 15.771C129.31 15.771 127.493 18.775 127.493 22.2296Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2899 0C31.4947 0 40.5798 9.91325 40.5798 21.9293C40.5798 33.9454 31.4947 43.8586 20.2899 43.8586C9.08502 43.8586 0 33.9454 0 21.9293C0 9.91325 9.08502 0 20.2899 0Z",
    fill: "#21275B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7791 21.9294C13.7791 28.2379 16.8074 33.3447 20.29 33.3447C23.924 33.3447 26.8009 28.2379 26.8009 21.9294C26.8009 15.621 23.7726 10.5142 20.29 10.5142C16.656 10.5142 13.7791 15.621 13.7791 21.9294Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.3685 64.5864C39.3685 64.5864 44.0624 64.8868 42.2454 69.2427L38.46 83.3615C38.46 83.3615 36.0373 88.168 48.1507 88.3182C48.1507 88.3182 62.081 87.7174 62.5353 76.7527C62.5353 76.7527 63.2924 71.4957 58.447 69.8435C58.447 69.8435 63.7466 65.037 61.4754 60.9816C61.4754 60.9816 56.7814 51.3688 41.3369 62.1832C41.3369 62.3334 38.9142 63.2346 39.3685 64.5864Z",
    fill: "#21275B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.4123 55.8748C65.4123 55.8748 62.6868 57.0764 65.1094 59.1792C65.1094 59.1792 65.8665 59.9302 65.4123 60.9816C65.4123 60.9816 64.6552 62.3334 66.1694 61.8828C66.1694 61.8828 68.8949 59.4796 68.592 57.2266C68.592 57.3768 67.8349 54.8234 65.4123 55.8748Z",
    fill: "#21275B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.1877 86.3655C84.1877 86.3655 80.5537 87.4169 82.2193 88.6185L84.0363 89.6699C84.0363 89.6699 84.642 89.9703 86.3076 89.3695C86.3076 89.3695 117.348 79.0056 129.31 79.1558C129.31 79.1558 131.127 79.1558 131.278 78.4048C131.278 78.4048 130.976 77.6538 128.402 77.6538C128.402 77.6538 102.055 80.5076 84.1877 86.3655Z",
    fill: "#21275B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.545 73.7485L45.1223 81.7092C45.1223 81.7092 46.0308 84.4128 48.1507 84.563C48.1507 84.563 52.8446 84.7132 54.9644 77.3534C54.9644 77.3534 55.7215 74.3494 51.6332 73.4481C51.4818 73.4481 49.0592 73.1477 47.545 73.7485Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.8161 62.1831L48.4534 67.8908C48.4534 67.8908 48.7562 69.6932 50.4218 69.8434C50.4218 69.8434 54.51 69.6932 56.1756 66.2386C56.1756 66.2386 57.387 61.8827 53.4501 61.5823C53.2987 61.5823 50.876 61.4321 49.8161 62.1831Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.5255 67.2899L76.4656 74.4996C76.4656 74.4996 76.1628 77.804 73.2858 77.5036C73.2858 77.5036 70.8632 76.4522 71.9231 71.3453C71.9231 71.3453 72.0745 65.1871 77.5255 67.2899Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.8631 87.1164C70.8631 87.1164 72.0744 85.9148 72.8315 86.5156C72.8315 86.5156 74.0429 88.4683 71.7716 92.2233C71.7716 92.2233 70.7117 94.9269 68.4404 93.4249C68.289 93.4249 66.6234 90.4209 70.8631 87.1164Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.074 73.4483C120.074 73.4483 118.257 72.6973 118.711 69.3929C118.711 69.3929 120.679 55.5744 124.01 49.4162C124.01 49.4162 124.919 48.3648 125.373 48.8154C125.373 48.8154 126.433 49.7166 125.676 51.6692C125.676 51.6692 124.465 56.4756 125.373 57.2266C125.373 57.2266 127.039 57.8274 128.099 56.6258C128.099 56.6258 131.43 54.9736 131.884 57.6772C131.884 57.6772 132.187 60.8315 131.127 65.6379C131.127 65.6379 130.37 68.9423 134.307 68.4917C134.307 68.4917 134.61 71.7961 129.31 71.7961C129.31 71.7961 125.373 71.9463 127.039 66.0885C127.039 66.0885 129.007 60.9817 126.736 59.9302C126.282 59.78 125.525 60.0804 124.768 60.9816C124.768 60.9816 123.859 63.3849 123.405 69.0925C123.253 69.2427 123.253 74.3495 120.074 73.4483Z",
    fill: "#21275B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_211_78"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 187,
    height: 96.5791,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOshKosh);
export default __webpack_public_path__ + "static/media/OshKosh.ce778658f0146326d949c09373d0da8e.svg";
export { ForwardRef as ReactComponent };